'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // Copyright (c) 2018 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _base = require('../../components/common/icons/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridLayerIcon = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GridLayerIcon, _Component);

  function GridLayerIcon() {
    (0, _classCallCheck3.default)(this, GridLayerIcon);
    return (0, _possibleConstructorReturn3.default)(this, (GridLayerIcon.__proto__ || Object.getPrototypeOf(GridLayerIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridLayerIcon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _base2.default,
        this.props,
        _react2.default.createElement('rect', {
          x: '11.2',
          y: '11.2',
          className: 'cr1',
          width: '13.1',
          height: '13.1',
          style: { opacity: 0.8 }
        }),
        _react2.default.createElement('rect', {
          x: '25.4',
          y: '11.2',
          className: 'cr2',
          width: '13.1',
          height: '13.1',
          style: { opacity: 0.8 }
        }),
        _react2.default.createElement('rect', { x: '39.6', y: '11.2', width: '13.1', height: '13.1', className: 'cr3' }),
        _react2.default.createElement('rect', {
          x: '11.2',
          y: '25.4',
          className: 'cr4',
          width: '13.1',
          height: '13.1',
          style: { opacity: 0.4 }
        }),
        _react2.default.createElement('rect', { x: '25.4', y: '25.4', className: 'cr5', width: '13.1', height: '13.1' }),
        _react2.default.createElement('rect', {
          x: '39.6',
          y: '25.4',
          className: 'cr6',
          width: '13.1',
          height: '13.1',
          style: { opacity: 0.8 }
        }),
        _react2.default.createElement('rect', { x: '11.2', y: '39.6', width: '13.1', className: 'cr1', height: '13.1' }),
        _react2.default.createElement('rect', {
          x: '25.4',
          y: '39.6',
          className: 'cr2',
          width: '13.1',
          height: '13.1',
          style: { opacity: 0.4 }
        }),
        _react2.default.createElement('rect', {
          x: '39.6',
          y: '39.6',
          className: 'cr3',
          width: '13.1',
          height: '13.1',
          style: { opacity: 0.4 }
        })
      );
    }
  }]);
  return GridLayerIcon;
}(_react.Component), _class.propTypes = {
  /** Set the height of the icon, ex. '16px' */
  height: _propTypes2.default.string,
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
}, _class.defaultProps = {
  height: '16px',
  predefinedClassName: 'grid-layer-icon',
  totalColor: 6
}, _temp);
exports.default = GridLayerIcon;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/kepler.gl/dist/layers/grid-layer/grid-layer-icon.js
// module id = 1436
// module chunks = 0